import React from 'react';
import {
  ShimmerButton,
  ShimmerCard,
  ShimmerTable,
  ShimmerThumbnail,
  ShimmerTitle
} from '../../../assets/shimmer';

const ListShimmer = () => {
  return (
    <ShimmerCard className="py-4 shimmer-code">
      <div className="d-flex align-items-center justify-content-between px-4">
        <ShimmerTitle line={1} className="w-25"></ShimmerTitle>
        <ShimmerButton size="sm" className="rounded-2"></ShimmerButton>
      </div>
      <div
        className="d-flex flex-column flex-md-row align-items-md-center filters px-4"
        style={{ gap: '10px' }}>
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '200px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '100px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '100px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '100px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '100px' }} />
      </div>
      <ShimmerCard className="px-2 pb-3 mt-2" style={{ boxShadow: 'none' }}>
        <ShimmerTable col={6} row={10}></ShimmerTable>
      </ShimmerCard>
    </ShimmerCard>
  );
};

export default ListShimmer;
